import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Tooltip,
} from "@fluentui/react-components";
import {
  Delete16Regular,
  Edit16Regular,
  MoreVertical20Regular,
} from "@fluentui/react-icons";
import { useSharedMenuStyles } from "theme/sharedStyles";
import { IDiagnosticCardMenuProps } from "./DiagnosticCardMenu.types";

export const DiagnosticCardMenu = ({
  onEdit,
  onDelete,
  onOpenChange,
}: IDiagnosticCardMenuProps): JSX.Element => {
  const sharedMenuStyles = useSharedMenuStyles();

  return (
    <Menu
      positioning={{ position: "below", align: "end" }}
      onOpenChange={(_e, data) => onOpenChange(data.open)}
    >
      <MenuTrigger>
        <Tooltip
          content="More options"
          relationship="label"
          showDelay={300}
          hideDelay={100}
        >
          <Button
            appearance="subtle"
            icon={<MoreVertical20Regular />}
            aria-label="More options"
          />
        </Tooltip>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem
            className={sharedMenuStyles.item}
            icon={<Edit16Regular />}
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
          >
            Edit
          </MenuItem>
          <MenuItem
            className={sharedMenuStyles.itemDanger}
            icon={
              <span className={sharedMenuStyles.itemIconDanger}>
                <Delete16Regular />
              </span>
            }
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            Delete
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
